import React, { useState } from 'react';
import { Modal, Button, Form, Alert, Spinner } from 'react-bootstrap';
import { authService } from '../../services/authService'; // ✅ Utilisation du service centralisé

const TwoFactorVerification = ({ show, onHide, onVerified, userEmail }) => {
  const [otpCode, setOtpCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleVerify = async () => {
    if (otpCode.length !== 6) {
      setError('Le code doit contenir 6 chiffres.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      // ✅ ÉTAPE 2 : Vérification de l'OTP via le backend
      const data = await authService.verifyOtp(userEmail, otpCode);
      
      // data contient { token, role } renvoyé par Spring Boot
      onVerified(data); 
    } catch (err) {
      setError(err || 'Code invalide ou expiré.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>🛡️ Vérification de sécurité</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center p-4">
        <p>Un code de vérification a été envoyé à :<br/><strong>{userEmail}</strong></p>
        
        {error && <Alert variant="danger">{error}</Alert>}

        <Form.Group className="mb-3">
          <Form.Control
            type="text"
            placeholder="000000"
            className="text-center fw-bold"
            style={{ fontSize: '2rem', letterSpacing: '0.5rem' }}
            value={otpCode}
            onChange={(e) => setOtpCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
          />
        </Form.Group>
        
        <Button 
          variant="primary" 
          className="w-100 py-2 fw-bold" 
          onClick={handleVerify}
          disabled={loading || otpCode.length !== 6}
        >
          {loading ? <Spinner size="sm" /> : 'Valider le code'}
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default TwoFactorVerification;